import { combineReducers, compose, createStore as _createStore, applyMiddleware, CombinedState } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';

import * as reducers from '../../reducers';
import { IApplicationState, TReduxActions, TReduxStore, IContext } from '../../types/redux';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(initialState: Partial<IApplicationState>, debugEnabled: boolean, context: IContext) {
  const rootReducer = combineReducers<IApplicationState, TReduxActions>(reducers);

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(context) as ThunkMiddleware<IApplicationState, TReduxActions>),
  ) as any; // eslint-disable-line

  const createStore = (): TReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IApplicationState, {}>(
      rootReducer,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(rootReducer);

    return storeReminder;
  }

  return createStore();
}
